import { cn } from '@/lib/utils';

interface BBotLogoProps {
  size?: string;
  className?: string;
}

export function BBotLogo({ size = 'w-12 h-12', className }: BBotLogoProps) {
  return (
    <img
      src="/logo.png"
      alt="DialogMe"
      className={cn(size, className)}
    />
  );
}
